import { useQueryParams } from '@solinkcorp/utils/hooks';
import { useCallback } from 'react';
import { SDM_LAYOUT_QUERY_PARAM } from '../constants';

/**
 * URL is the canonical "what should be selected on load" signal; the
 * controller still owns resolved selection state and the pending-name dance
 * for newly-created layouts.
 */
export function useSelectedLayoutId(): readonly [
  string | undefined,
  (id: string | undefined) => void,
] {
  const [query, setQuery] = useQueryParams();
  const layoutId = query.get(SDM_LAYOUT_QUERY_PARAM);
  const setSelectedLayoutId = useCallback(
    (id: string | undefined) => {
      setQuery({ [SDM_LAYOUT_QUERY_PARAM]: id }, true);
    },
    [setQuery],
  );
  return [layoutId, setSelectedLayoutId] as const;
}
